module.exports = __webpack_public_path__ + "c8ddf1e5e5bf3682bc7bebf30f394148.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.6.3
 ** module id = 287
 ** module chunks = 1
 **/